<template>
	<div>
		<div>
			<Button type="primary" icon="ios-search" @click="searchByConditionsView">搜索</Button>
			<Button type="primary" style="margin-left: 20px;" @click="showDown = true">设置心跳间隔</Button>
		</div>

		<Table ref="table" size="large" border stripe :loading="loading" :columns="columns1" :data="data1"
			@on-selection-change="onSelectionChange" style="margin: 20px 0;">
			<template slot-scope="{ row, index }" slot="deparams">
				<div style="display: flex;justify-content: space-around;">
					<Button type="primary" @click="" style="padding: 5px 5px 6px;"></Button>
				</div>
			</template>
		</Table>
		<Page :current="currentPage" :total="totalRows" :page-size="pageSize" :page-size-opts="[5, 10, 20, 30, 40]"
			show-sizer show-total @on-change="changePage" @on-page-size-change="changePageSize" />

		<Modal title="Title" v-model="showDown" class="check_grop"  width="380">
			<div slot="header">
				<span>{{showTitle}}</span>
			</div>
			<div>
				<span style="display: inline-block;margin: 20px;">{{valveProfile['paramSet']['heartbeat'].params.cycle.cn}}</span>
				<InputNumber ref="getCycle" v-model="valveProfile['paramSet']['heartbeat'].params.cycle.default" style="width: 200px"/>
				{{ valveProfile['paramSet']['heartbeat'].params.cycle.unit }}
			</div>
			<div slot="footer">
				<Button :loading="submitLoading" type="info" size="large" long
					@click="selectAlarm()">参数下发</Button>
			</div>
		</Modal>
		<Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
				<p slot="header" style="color:#0066FF;text-align:center">
					<span>搜索</span>
				</p>
				<div style="padding-left: 20px;">
					<CheckboxGroup v-model="selectedConditions" class="check_group">
						<div>
							<Checkbox label="name">
								<span>姓名</span>
							</Checkbox>
							<Input v-model="condition.name" placeholder="" />
						</div>
						<div>
							<Checkbox label="num">
								<span>设备编号</span>
							</Checkbox>
							<Input v-model="condition.num" placeholder="" />
						</div>
						<div>
							<Checkbox label="type">
								<span>通讯类型</span>
							</Checkbox>
							<Select :readonly="showType=='show'" v-model="condition.type">
								<Option :value="1" :key="1">NB</Option>
								<Option :value="2" :key="2">WIFI</Option>
							</Select>
						</div>
						<div>
							<Checkbox label="gasType">
								<span>用气类型</span>
							</Checkbox>
							<Select :readonly="showType=='show'" v-model="condition.gasType">
								<Option :value="1" :key="1">液化天然气</Option>
								<Option :value="2" :key="2">液化石油气</Option>
							</Select>
						</div>
					</CheckboxGroup>
				</div>
				<div slot="footer">
					<Button type="info" size="large" long @click="searchByCondition">立即搜索</Button>
				</div>
			</Modal>

	</div>
</template>

<script>
	export default {
		name: "alarm_Heartbeat_Manage",
		data() {
			let that = this;
			return {
				columns1: [{
						type: "selection",
						width: 50,
						align: "center"
					},
					{
						title: "姓名",
						width: 100,
						key: "name",
						align: "center"
					},
					{
						title: "电话",
						width: 200,
						key: "telephone",
						align: "center"
					},
					{
						title: "地址",
						width: 350,
						key: "address",
						align: "center"
					},
					{
						title: "设备编号",
						width: 200,
						key: "num",
						align: "center"
					},
					{
						title: "公司名称",
						width: 300,
						key: "corporate",
						align: "center"
					},
					{
						title: "通讯方式",
						width: 100,
						align: "center",
						render: function(h, params) {
							return h(
								"div",
								params.row.type == 1 ? 'NB' : 'WIFI'
							);
						}
					},
					{
						title: "用气类型",
						width: 150,
						align: "center",
						render: function(h, params) {
							return h(
								"div",
								params.row.gasType == 1 ? "液化天然气" : "液化石油气"
							);
						}
					},
				],
				meterId: '',
				valveProfile: {},
				importUrl: '/api/alarm/admin/alarm/imports',
				selection: [],
				currentRow: {},
				data1: [],
				loading: false,
				submitLoading: false,
				modal8: false,
				showDown: false,
				currentPage: 1,
				totalRows: 0,
				pageSize: 30,
				selectedCondition: [],
				requestBody: {},
				showBindCompany: false,
				bindCompanyNum: '',
				showBindAddress: false,
				bindAddressId: '',
				showType: 'show',
				showTitle: '参数设置',
				showDialog: false,
                content:'',
				mainType: "paramSet",
                subType: "heartbeat",
				condition: {
					id: '',
					mac: '',
					happenTimeRange: [],
				},
			};
		},
		created() {
			this.getDataList();
			this.getAlarmProfile();
		},
		mounted() {

		},
		methods: {
			getAlarmProfile() {
            // 调用接口查询
            var that = this;
            that.loading = true;
            $.ajax({
                url: "/api/alarm/admin/message/getWIFIProfile",
                success: function (result) {
                    if (!result.success) {
                        that.$Notice.error({
                            title: "异常",
                            desc: result.msg
                        });
                        return;
                    }
                    that.valveProfile = result.data;
                },
                error: function () {
                    that.$Notice.error({
                        title: "异常",
                        desc: "网络异常"
                    });
                },
                complete: function () {
                    that.loading = false;
                }
            });
        },
			dateFtt(fmt, date) {
				return global.dateFtt(fmt, new Date(date));
			},
			clickImport() {
				this.$refs.upload.$el.children[0].children[0].dispatchEvent(new MouseEvent('click'));
			},
			selectAlarm() {
				let that = this;
				if (that.selection.length == 0) {
					that.$Notice.info({
						title: "提示",
						desc: "请选择数据"
					});
					return;
				}

				let numArray = [];
				for (let i in that.selection) {
					let mac = that.selection[i].mac;
					numArray.push(mac);
				}
				that.$Modal.confirm({
					title: '提示',
					content: '<p>请确认下发参数</p>',
					onOk: () => {
						that.loading = true;
						this.showDown = false;
						this.content = '{"cycle":"'+this.$refs.getCycle.value+'"}'
						$.ajax({
							 url: "/api/alarm/admin/message/down",
							// url:"",
							type: "post",
							data: {
								numJoin: numArray.join(','),
                                content: this.content,
                                mainType: this.mainType,
                                subType: this.subType,
                                state: 0
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									return;
								}
								
								that.getDataList();
							},
							error: function() {
								that.$Notice.error({
									title: "异常",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			onSelectionChange(selection) {
				this.selection = selection;
			},
			// 修改页面容量
			changePageSize(pageSize) {
				this.pageSize = pageSize;
				this.request();
			},
			changePage(index) {
				this.requestBody = {};
				for (var temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "meterId") {
						if (this.meterId == "") {
							continue;
						}
						this.requestBody["meterId"] = this.meterId;
					}
				}

				this.loading = true;
				this.currentPage = index;
				this.getDataList();
			},
			// 按条件检索点击事件
			searchByCondition() {
				this.requestBody = {};
				for (let i in this.selectedConditions) {
					let selectedCondition = this.selectedConditions[i]
					switch (selectedCondition) {
						case 'happenTime':
							let happenTimeBegin = this.condition.happenTimeRange[0];
							if (happenTimeBegin != '') {
								this.requestBody['happenTimeBegin'] = global.dateFtt('yyyy-MM-dd hh:mm:ss',
									happenTimeBegin);
							}
							let happenTimeEnd = this.condition.happenTimeRange[1];
							if (happenTimeEnd != '') {
								this.requestBody['happenTimeEnd'] = global.dateFtt('yyyy-MM-dd hh:mm:ss', happenTimeEnd);
							}
							if (this.id != "") {
								this.requestBody["id"] = this.id;
							}
							if (this.num != "") {
								this.requestBody["num"] = this.num;
							}
							if (this.type.value != "") {
								this.requestBody["type"] = this.type;
							}
							if (this.gasType.value != "") {
								this.requestBody["gasType"] = this.gasType;
							}
							if (this.subType.value != "") {
								this.requestBody["subType"] = this.subType;
							}
							break;
						default:
							let value = this.condition[selectedCondition];
							if (value == null || value == '') {
								break;
							}

							this.requestBody[selectedCondition] = value;
							break;
					}
				}

				this.loading = true;
				this.modal8 = false;
				this.currentPage = 1;
				this.getDataList();
			},
			getDataList() {
				var that = this;
				that.loading = true;
				if (localStorage.getItem("isAdmin") != "true") {
				that.requestBody["companyNum"] = localStorage.getItem("personnelGroverningBodyId");
    			}
				$.ajax({
					url: "/api/alarm/admin/alarm/getPage?currentPage=" +
						that.currentPage +
						"&pageSize=" +
						that.pageSize +
						"&paging=true",
					type: "post",
					data: that.requestBody,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}
						that.data1 = result.data.list;
						that.totalRows = result.data.totalRows;
						that.selection = [];
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			// 显示条件检索页面
			searchByConditionsView() {
				this.modal8 = true;
			}
		}
	};
</script>

<style>
	.ivu-notice-notice {
		width: 500px;
		right: 160px;
	}

	.query_condition {
		border: 1px solid #c0c0c0;
		padding: 2px;
		margin: 2px;
		border-radius: 5%;
	}
	.param-menu {
		height: 370px;
		overflow-y: scroll;
	}
	.check_grop div {
		margin-bottom: 1px;
	}
	.param-menu::-webkit-scrollbar {
		width: 5px;
	}

	.param-menu::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: lightgray;
	}

	.param-menu::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
	}

	.param-content {
		height: 280px;
		overflow-y: scroll;
	}

	.param-content::-webkit-scrollbar {
		width: 5px;
	}

	.param-content::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: lightgray;
	}

	.param-content::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
	}
	
</style>
